<template>
    <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="meta"
            :server-items-length="total"
            :footer-props="{
              itemsPerPageOptions: [10, 25, 50]
            }"
            :loading="isFetch"
            loading-text="Загрузка данных... Ожидайте"
    >
        <template v-slot:top>
            <v-toolbar flat dense>
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    color="green"
                    @click="load"
                    :disabled="isFetch"
                >
                    <v-icon>mdi-cached</v-icon>
                </v-btn>
            </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
            <v-row>
                <v-col cols="4">
                    <v-btn small color="primary" @click="() => $router.push({name: 'JurEditPage', params:{id: item.id}})">
                        <v-icon>
                            mdi-note-edit-outline
                        </v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="4">
                    <v-btn small color="error" @click="() => onRemoveJur(item.id)">
                        <v-icon>
                            mdi-delete
                        </v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="4">
                    <v-btn small color="warning" @click="() =>  $router.push({name: 'JurContactsIndex', params:{jurId: item.id}})">
                        <v-icon>
                            mdi-book-account
                        </v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </template>
    </v-data-table>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "JurTable",
    mounted() {
        this.load();
    },
    data(){
        return {
            isFetch: false,
            headers: [
                {
                    text: 'ИНН',
                    sortable: false,
                    value: 'inn',
                },
                {
                    text: 'ОГРН',
                    sortable: false,
                    value: 'ogrn',
                },
                {
                    text: 'КПП',
                    sortable: false,
                    value: 'kpp',
                },
                {
                    text: 'Полное наименование юридического лица',
                    sortable: false,
                    value: 'full_name',
                },
                {
                    text: 'Краткое наименование юридического лица',
                    sortable: false,
                    value: 'short_name',
                },
                {
                    text: 'Юридический адрес юридического лица',
                    sortable: false,
                    value: 'legal_address',
                },
                {
                    text: 'Фактический адрес юридического лица',
                    sortable: false,
                    value: 'actual_address',
                },
                {
                    text: 'Должность директора',
                    sortable: false,
                    value: 'director_position',
                },
                {
                    text: 'Имя директора',
                    sortable: false,
                    value: 'director_name',
                },
                {
                    text: 'Отчество директора',
                    sortable: false,
                    value: 'director_patronymic',
                },
                {
                    text: 'Фамилия директора',
                    sortable: false,
                    value: 'director_surname',
                },
                {
                    text: 'Действия',
                    sortable: false,
                    value: 'actions',
                },
            ],
            jurData: [],
            total: 0,
            meta: {
                itemsPerPage: 10,
                page: 1,
            }
        }
    },
    watch: {
        meta: {
            handler () {
                this.load();
            },
            deep: true,
        }
    },
    methods: {
        ...mapActions('notifications', ['SHOW_RESPONSE_ERROR', 'SHOW_SUCCESS']),
        async load(){
            try{
                this.isFetch = true;
                let {data} = await this.getClient().getJurAll(this.meta.page, this.meta.itemsPerPage);
                this.setJurData(data.data);
                this.setMeta(data.meta);
            }catch (e) {
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Ошибка загрузки данных ('});
                console.log(e);
            }finally {
                this.isFetch = false;
            }
        },
        setJurData(data){
            this.jurData.splice(0, this.jurData.length, ...data);
        },
        setMeta(meta){
            this.total = meta.total;
        },
        async onRemoveJur(jurId){
            try{
                this.isFetch = true;
                await this.getClient().jurRemove(jurId);
                this.SHOW_SUCCESS('Успешно удалено');
                this.load();
            }catch (e) {
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Ошибка удаления ('});
                console.log(e);
            }finally {
                this.isFetch = false;
            }
        }
    },
    computed: {
        ...mapGetters( 'contragents', ['getClient']),
        items(){
            return this.jurData;
        }
    }
}
</script>
<style scoped>

</style>